import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { PublicEnquiryModel } from "../../../../domain/PublicEnquiry";
import { closePublicEnquiry } from "../../../../redux/actions";

type CreateDialogProps = {
  peItem: PublicEnquiryModel;
  onClose: () => void;
};

export const ClosePeDialog: React.FC<CreateDialogProps> = ({
  peItem,
  onClose,
}) => {
  const dispatch = useDispatch();
  const onClosePe = (id: string) => {
    dispatch(closePublicEnquiry(id));
    onClose();
  };

  return (
    <>
      <DialogTitle data-test="assign-ctr-dialog-title">
        Close pe
        <Divider />
      </DialogTitle>
      <DialogContent>
        Are you sure you want to close this request?
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          data-test="cancel-close-button"
          onClick={() => onClose()}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          data-test="confirm-close-button"
          onClick={() => onClosePe(peItem.id)}
        >
          Confirm
        </Button>
      </DialogActions>
    </>
  );
};
